//@flow
import * as React from 'react';

import { Route, Switch } from 'react-router-dom';
import ReprocessamentoCrudList from './ReprocessamentoCrudList';

export default class ReprocessamentoCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/reprocessamento"
            exact
            component={ReprocessamentoCrudList}
          />
        </Switch>
      </React.Fragment>
    );
  }
}
